import { readVersionFromEtag, sendOutsideSaveAttempt } from './saveHttp';

/**
 * Hand-written client for the connector-next course-stage endpoint (the
 * generated client is not used for mutations that need If-Match — the HTTP
 * conventions live in `saveHttp.ts`, shared with the save clients).
 *
 * The stage and the stages marked done travel together in one request,
 * because moving the stage and marking one finished are separate statements
 * the caller makes explicitly. The server stores what it is sent, except that
 * a course leaving Received has Received marked done. The write is not part
 * of a dataset save, so it carries no save attempt id. Resolves to the
 * patient's next version.
 */
export async function postCourseStage(
    patientId: string,
    stage: string,
    done: readonly string[],
    ifMatch: string
): Promise<string> {
    const response = await sendOutsideSaveAttempt(
        `/api/patients/${patientId}/course-stage`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ stage, done }),
        },
        ifMatch
    );
    return readVersionFromEtag(response);
}
